define('modules/editor/models/movablestate',['require','exports','module','backbone'],function(require, exports, module){
	"use strict";
	var Backbone = require("backbone");
	/**
	Keeps the move/drag/drop interactions global state
	**/
	var MovableState = Backbone.Model.extend({
		defaults: {
			movingItem: null,
			clickOffset: null,
			movingLastPos: null
		},
		startMoving: function(view, clickOffset){
			this.set({
				movingItem: view,
				clickOffset: clickOffset
			});
		},
		stopMoving: function(){
			this.set({
				movingItem: null,
				clickOffset: null,
				movingLastPos: null
			});
		},
		//save last position (NOTE: absolute coordinates)
		setLastPosition: function(mousex,mousey){
			this.set("movingLastPos", {x: mousex, y: mousey});
		},
		getLastPosition: function(){
			return this.get("movingLastPos");
		},
		getMovingView: function(){
			return this.get("movingItem");
		},
		getClickOffset: function(){
			return this.get("clickOffset");
		}
	});
	module.exports = MovableState;
});

